import { FeatureFlag } from '@core/const';
import { StateUtils } from '@spartacus/core';
import { FEATURE_FLAGS } from '../core-state';

export const FEATURE_FLAGS_LOAD = '[FeatureFlags] FeatureFlags Load';
export const FEATURE_FLAGS_LOAD_SUCCESS = '[FeatureFlags] FeatureFlags Load Success';
export const FEATURE_FLAGS_LOAD_FAIL = '[FeatureFlags] FeatureFlags Load Fail';

export class FeatureFlagsLoad extends StateUtils.LoaderLoadAction {
  readonly type = FEATURE_FLAGS_LOAD;

  constructor() {
    super(FEATURE_FLAGS);
  }
}

export class FeatureFlagsLoadFail extends StateUtils.LoaderFailAction {
  readonly type = FEATURE_FLAGS_LOAD_FAIL;

  constructor() {
    super(FEATURE_FLAGS);
  }
}

export class FeatureFlagsLoadSuccess extends StateUtils.LoaderSuccessAction {
  readonly type = FEATURE_FLAGS_LOAD_SUCCESS;

  constructor(public payload: FeatureFlag[]) {
    super(FEATURE_FLAGS);
  }
}

export type FeatureFlagsLoadAction = FeatureFlagsLoad | FeatureFlagsLoadFail | FeatureFlagsLoadSuccess;
